/**
 * TEI (Theological Education Institution) manifest.
 *
 * One build serves several TEIs. Branding is resolved from REACT_APP_TEI at build time;
 * field visibility, features and labels come from the back-end manifest (GET /api/tei),
 * loaded once before the app renders (see src/index.js) so every helper below is synchronous.
 *
 * Rules: anything TEI-specific goes through this module. Do not branch on the slug in components,
 * use hasFeature() / teiLabel() instead (field visibility is driven by permissions seeded from the manifest);
 * the slug is only for picking a branding entry
 * or a whole legacy view variant.
 */
import { axios } from '@Root/API/axios'
import ctfLogo from '@Root/assets/icons/ctf-logo.png'
import stHildLogo from '@Root/assets/icons/st-hild-logo.png'
import smcLogo from '@Root/assets/icons/SMC_Logo.png'
import trinityLogo from '@Root/assets/icons/TrinLogo.png'

// profile is the build-time fallback used only when GET /api/tei is unavailable.
const BRANDING = {
  ctf: { logo: ctfLogo, logoHeight: 50, profile: 'federation' },
  sthild: { logo: stHildLogo, logoHeight: 50, profile: 'federation' },
  stmellitus: { logo: smcLogo, logoHeight: 50, profile: 'college' },
  trinity: { logo: trinityLogo, logoHeight: 36, profile: 'college' },
}

export const TEI_SLUG = String(process.env.REACT_APP_TEI || '')
  .trim()
  .toLowerCase()

let manifest = {
  slug: TEI_SLUG,
  name: '',
  short_name: '',
  profile: BRANDING[TEI_SLUG]?.profile || '',
  labels: {},
  optional: {},
  fields: {},
  features: {},
}

export const loadTei = async () => {
  const { data } = await axios.get('tei')
  manifest = data
  return manifest
}

export const tei = () => manifest

export const teiBranding = () => BRANDING[manifest.slug] || BRANDING[TEI_SLUG] || BRANDING.sthild

export const hasFeature = name => Boolean(manifest.features[name])

export const teiLabel = (key, fallback = '') => manifest.labels[key] ?? fallback
